import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana79Div2M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1461_7644)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M500.499 641.941L458.866 554.71L502.481 532.902L544.114 620.134L500.499 641.941Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M575.834 606.252L544.114 620.13L502.481 532.898L534.201 515.056L585.747 566.601C592.091 587.22 581.782 601.626 575.834 606.252Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M484.636 467.465L534.199 515.046L496.531 534.871L458.863 554.696L431.108 495.22L484.636 467.465Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M391.459 380.241L484.638 467.472L431.11 495.228L379.564 386.189C379.564 376.673 387.494 378.259 391.459 380.241Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_7644" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_7644" transform="matrix(0.00271937 0 0 0.00360516 -5.97931 -2.34326)"/>
    </pattern>
    <image id="image0_1461_7644" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};